import React from "react";
import Text, {
    TEXT_COLOR,
    TEXT_KIND,
    TEXT_SIZE,
  } from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
import Icon from "@/bit/components/components.icon-glyph";
import styled from 'styled-components';

const Stepper = styled.div`
  height: 100px;
  display: flex;
  .visible {
      display: none;
  }
  .no-visible {
      display: block;
  }
  @media (max-width: 768px) {
    .stepperForm-ball {
      display: none !important;
    }
    .stepperForm {
      height: 50px;
    }
  }
  .stepperForm-wrapper {
  position: relative;
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  }

  .stepperForm-bars {
  position: relative;
  width: 100%;
  height: 4px;
  }

  .stepperForm-bar-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  border-radius: 2px;
  }

  .stepperForm-bar-progress {
  position: absolute;
  height: 100%;
  background-color: #019DF4;
  border-radius: 2px;
  transition: width 0.5s ease-in-out;
  }

  .stepperForm-ball {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  padding: 8px;
  background: white;
  }

  .ball-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: white;
  border: solid 1px #6B6C6F;
  cursor: auto;
  pointer-events: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s;
  }

  .ball-circle.active {
  background-color: #0079BB;
  border: none;
  }

  .ball-label {
  position: absolute;
  top: 40px;
  white-space: nowrap;
  span {
    text-wrap: unset;
  }
`

const StepperForm = ({ steps, currentStep = 1, onStepClick }) => {

  const handleStepClick = (step) => {
    if (onStepClick) onStepClick(step);
  };

  const progress = ((currentStep - 1) / (steps.length - 1)) * 100;

  return (
    <Stepper>
     <div className="stepperForm-wrapper">
      <div className="stepperForm-bars">
        <div className="stepperForm-bar-background"></div>
        <div 
          className="stepperForm-bar-progress" 
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      {steps.map((step, index) => (
        <div
          key={index}
          className="stepperForm-ball"
          style={{
            left: `calc(${(index / (steps.length - 1)) * 100}% + ${20 - (index / (steps.length - 1))* 40}px)`,
          }}
        >
        <CustomLink
            onClick={currentStep > index + 1 ? () => handleStepClick({step, index}) : () => {}}
            className={`${currentStep === index + 1 ? "active ball-circle" : currentStep < index +1 ? 'ball-circle' : ''}`}
            >
                <Icon id="ok-circle-l" height={24} color={TEXT_COLOR.BLUE_MOVISTAR} className={currentStep > index + 1 ? "no-visible" : "visible"}/>
                <Text
                    color={currentStep === index + 1 ? TEXT_COLOR.WHITE : TEXT_COLOR.GREY5}
                    text={index + 1}
                    size={TEXT_SIZE.CAPTION}
                    kind={TEXT_KIND.SPAN}
                    className={currentStep > index + 1 ? "visible" : "no-visible"}
                />
            </CustomLink>
          {step.label && <span className="ball-label">
            <Text
                color={TEXT_COLOR.GREY5}
                text={step.label}
                size={TEXT_SIZE.CAPTION}
                kind={TEXT_KIND.SPAN}
            />
            </span>}
        </div>
      ))}
    </div>
    </Stepper>
  );
};

export default StepperForm;